// useAuth() — subscribes to Firebase auth state and exposes the current
// Firebase user. useUser() (in useUser.ts) trades the ID token for a HubUser
// via /api/me; keep them separate so components that only need to know
// "am I signed in" don't force the /api/me round-trip.
import { useEffect, useState } from "react";
import { onAuthStateChanged, type User } from "firebase/auth";
import { auth } from "./firebase";

export interface AuthState {
  user: User | null;
  ready: boolean;
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({
    user: auth.currentUser,
    ready: false,
  });
  useEffect(() => {
    return onAuthStateChanged(auth, (user) => {
      setState({ user, ready: true });
    });
  }, []);
  return state;
}
